import { Alert } from '@cast/design-system';

export const PlatformUsageBillingAlert = () => (
  <Alert color="info" sx={{ mb: 24 }}>
    Usage metrics shown here represent month-to-date normalized utilization and
    do not automatically equal your final bill. If you have a custom contract
    agreement, these raw product metrics will be consolidated at the time of
    billing according to your contract terms.
  </Alert>
);
